<template>
    <div class="form-box">
        <div class="form-right from7-r">
            <div style="width:100%;height:6vh;padding-left:1vw;background:#fff;display:flex;align-items: center;border-bottom: 3px solid #ecf0f5;">
                项目关键节点计划
            </div>
            <div style="width:100%;height:calc( 100% - 6vh );position: relative;padding:1vh;background:#fff;overflow: auto;">
                <el-table
                    :data="tableData"
                    style="width: 100%;margin-bottom: 20px;"
                    row-key="projectNodeId"
                    :show-header="false"
                    height="100%"
                    default-expand-all
                    :tree-props="{children: 'childList', hasChildren: 'hasChildren'}">
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column prop="index" label="序号" width="80">
                        <template slot-scope="scope">
                            <span>{{scope.row.index}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="index" label="名称" width="200">
                        <template slot-scope="scope">
                            <p style="width:100%;text-align: left; margin: 30px 0;">{{scope.row.nodeTypeName}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="index" label="进度">
                        <template slot-scope="scope">
                            <el-progress :text-inside="true" :stroke-width="40" :percentage="parseFloat(scope.row.completeRate)"></el-progress>
                        </template>
                    </el-table-column>
                    <el-table-column prop="index" label="时间" width="200">
                        <template slot-scope="scope">
                            <p>{{scope.row.completeTime}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="index" label="操作" width="50">
                        <template slot-scope="scope">
                            <p style="width:100%;" @click="addNodeProcess(scope.row)">
                                <i v-if="!scope.row.childList || scope.row.childList.length==0" style="cursor: pointer;" class="el-icon-arrow-right"></i>
                            </p>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- <el-table :data="tableData" border style="width: 100%" height="100%" :header-row-class-name="'table-head'">
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column prop="index" label="序号" width="200">
                        <template slot-scope="scope">
                            <span>{{scope.row.index}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="nodeTypeName" label="关键节点">
                        <template slot-scope="scope">
                            <span>{{scope.row.nodeTypeName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="startTime" label="计划开始时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.startTime}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="actualStartTime" label="实际开始时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.actualStartTime}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="completeTime" label="计划完成时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.completeTime}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="actualCompleteTime" label="实际完成时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.actualCompleteTime}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="actualCompleteTime" label="实际完成情况">
                        <template slot-scope="scope">
                            <span  v-if="scope.row.intervalDay>0" style="color:#f00">滞后{{scope.row.intervalDay}}天</span>
                            <span  v-if="scope.row.intervalDay<0" style="color:#409eff">提前{{scope.row.intervalDay}}天</span>
                            <span  v-if="scope.row.intervalDay==0">按时完成</span>
                        </template>
                    </el-table-column>
                </el-table> -->
                <!-- <div v-for="(item,index) in tableData" :key="index" style="width:100%;height:auto;position: relative;">
                    <div class="father-item" style="width:100%;height:10vh;position: relative;display:flex;align-items: center;align-content: center;">
                        <p style="width:10%;text-align: left;">{{item.index}}.{{item.nodeTypeName}}</p>
                        <p style="width:calc( 80% - 5vw );">
                            <el-progress :text-inside="true" :stroke-width="40" :percentage="parseFloat(item.completeRate)"></el-progress>
                        </p>
                        <p style="width:10%;">{{item.completeTime}}</p>
                        <p style="width:5vw;" @click="addNodeProcess(item)">
                            <i v-if="!item.childList || item.childList.length==0" class="el-icon-arrow-right"></i>
                        </p>
                    </div>
                    <div v-for="(child,i) in item.childList" :key="i" class="child-item" style="width:100%;height:10vh;position: relative;display:flex;align-items: center;align-content: center;">
                        <p style="width:10%;text-align: left;padding-left:1vw;">{{child.nodeTypeName}}</p>
                        <p style="width:calc( 80% - 5vw );">
                            <el-progress :text-inside="true" :stroke-width="40" :percentage="parseFloat(child.completeRate)"></el-progress>
                        </p>
                        <p style="width:10%;">{{child.completeTime}}</p>
                        <p style="width:5vw;" @click="addNodeProcess(child)">
                            <i class="el-icon-arrow-right"></i>
                        </p>
                    </div>
                </div> -->
            </div>
        </div>
        <!-- 新增窗口 -->
        <el-dialog
            title="添加"
            :visible.sync="addVis"
            center
            :append-to-body="true"
            :lock-scroll="false"
            class="add-form"
            width="30%"
        >
            <el-form
                :model="node"
                ref="node"
                label-width="150px"
                :label-position="labelPosition"
            >
                <el-form-item label="">
                   <el-input-number v-model="node.completeRate" :precision="2" :min="curMin" :max="100" label=""></el-input-number> %
                </el-form-item>
                <el-form-item label="实际开始时间：">
                   <el-date-picker
                        v-model="node.actualStartTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="月份：">
                   <el-date-picker
                        v-model="node.writeTime"
                        type="month"
                        value-format="yyyy-MM"
                        placeholder="选择月">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="描述：" v-if="node.completeRate==100">
                    <el-input type="textarea" :rows="5" placeholder="请输入描述" v-model="node.describes"></el-input>
                </el-form-item>
                <el-form-item label="添加照片：" v-if="node.completeRate==100">
                    <el-upload
                        class="avatar-uploader"
                        v-bind:action="uploadUrl"
                        :headers="uploadHead"
                        :data="{type:239}"
                        :show-file-list="false"
                        :on-success="handleIconSuccess"
                    >
                        <img v-if="node.picture" :src="baseCtx+ node.picture" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addVis = false">取 消</el-button>
                <el-button type="primary" @click="sumbitAddRow()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import base from '../../../untils/base'
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
import file from '../../ent/file.vue'
export default {
  components: { file },
    data(){
        return{
            groupId:'',
            // dataTree:[],
            // defaultProps: {
            //     children: 'list',
            //     label: 'name'
            // },
            // projectId:'',//当前项目id
            // currentNodekey:'',//当前树形选中值
            // expandedkeys:[],//树形展开值
            dataText: '数据加载中...',
            tableData:[],
            // curId:0,
            addVis:false,
            labelPosition:'right',
            activeNames:[],
            curMin:0,
            node:{
                projectNodeId:'',
                completeRate:'',
                describes:'',
                picture:'',
                writeTime:'',
                actualStartTime:'',
            },
            baseCtx:base.httpCtx,
            uploadUrl: myHttp.uploadPhotosAndThumbnail, //上传地址
            uploadHead: {
                accessToken: util.session.get('token')
            },
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        // this.getLeftMenu()
        this.getData()
    },
    methods:{
        //获取数据
        getData(){
            var that = this
            this.tableData = []
            myHttp.appProjectNodeList({
                projectId:this.groupId
            }).then(function(resp){
                console.log(resp)
                if(resp.data.code=='200'){
                    var list = resp.data.data.projectNodeList||[]
                    for(var i=0;i<list.length;i++){
                        list[i].index = i+1
                        list[i].childList = list[i].childList?list[i].childList:[]
                        list[i].projectNodeId = list[i].projectNodeId?list[i].projectNodeId:'test0'+i
                    }
                    that.tableData = list
                    if(list.length==0){
                        that.dataText = '暂无数据'
                    }
                }else{
                    that.dataText = '暂无数据'
                }
            })
        },

        //展示弹出框
        addNodeProcess(row){
            if(row.childList && row.childList.length>0)return;
            this.addVis = true
            this.node.projectNodeId = row.projectNodeId
            this.node.completeRate = row.completeRate
            this.node.describes = row.completeRate==100?row.describes:''
            this.node.picture = row.completeRate==100?row.picture:''
            this.node.writeTime = row.completeRate==100?row.writeTime:''
            this.node.actualStartTime = row.completeRate==100?row.actualStartTime:''
            this.curMin = parseFloat(row.completeRate)
        },

        //上传返回
        handleIconSuccess(res,file){
            if(res.code=='200'){
                this.icon = URL.createObjectURL(file.raw)
                this.node.picture = res.data.savePhotoUrls
                // this.addForm.thumbnailUrl =res.data.saveThumbnailUrls
            }
        },
        //添加
        sumbitAddRow(){
            var that = this
            myHttp.increaseCompleteRate(this.node).then(function(resp){
                if(resp.data.code=='200'){
                    that.$message.success('添加成功')
                    that.addVis = false
                    that.getData()
                }else{
                    that.$message.error(resp.data.msg)
                }
            })
        },

        //返回
        goBack(){
            this.$router.go(-1)
        },
    }
}
</script>

<style scoped>
    .form-box{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        padding: 1vh;
    }
    .form-right{
        width: 100%;
        height: 100%;
        position: relative;
        
    }

    .father-item:hover,.child-item:hover{
        background: #E7F1FB;
        cursor: pointer;
    }
</style>

<style>
    @import '../../../assets/css/common.css';
    .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #dddddd;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #dddddd;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #dddddd;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #dddddd;
    }
    .from7-r .el-table--border th:nth-child(3),.from7-r .el-table--border td:nth-child(3){
        border-right: 1px solid #dddddd;
    }
    .from7-r .el-table--border th:nth-child(5),.from7-r .el-table--border td:nth-child(5){
        border-right: 1px solid #dddddd;
    }
    .form-right .el-progress-bar__outer{
        background-color: #E0E0E0;
    }
    .form-right .el-progress-bar__innerText{
        font-size: 1vw;
    }
</style>